import { MediaQueries, ThemeProps } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledSponsoredBy = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem 0;

  &[data-type-mobile='true'] {
    justify-content: space-between;
  }
`
export const StyledStickySponsoredBy = styled.div`
  display: flex;
  width: fit-content;
  height: 40px;
  align-items: center;
  justify-content: center;
  padding: 0.375rem;
  margin-bottom: 8px;
  background-color: ${(props: ThemeProps) => props.theme.mbColors.yellow};
  border-radius: 0.75rem;
  cursor: pointer;
  text-decoration: none;
  &[data-align-left='true'] {
    justify-content: start;
  }
  .sticky-sponsored-info-icon {
    display: inline;
  }

  &[data-show-popup='true'] {
    .sticky-sponsored-info-icon {
      position: relative;
      &:before {
        position: absolute;
        z-index: 9;
        top: calc(100% + 0.2rem);
        left: 50%;
        border-right: 1rem transparent solid;
        border-bottom: 1rem white solid;
        border-left: 1rem transparent solid;
        content: ' ';
        transform: translateX(calc(-50% + 3px));
      }
    }
  }
`
export const StyledStickySponsoredPopup = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  &[data-align-left='true'] {
    left: 175px;
  }
  width: 350px;
  padding: 1rem;
  border: 1px solid #f2f2f2;
  background: white;
  border-radius: 6px;
  transform: translateX(-50%);
  ${MediaQueries.mbDown} {
    width: calc(100% - 2rem);
  }
  .button-container {
    display: flex;
    justify-content: space-between;
    button {
      flex: 1;
    }
    button:first-child {
      margin-right: 0.5rem;
      ${MediaQueries.mbUp} {
        margin-right: 1rem;
      }
    }
  }
`

export const StyledStickySponsoredByContainer = styled.div`
  display: flex;
  padding: 6px 16px 6px 8px;
  background-color: ${(props: ThemeProps) => props.theme.mbColors.toneYellow};
  border-radius: 12px;
  width: fit-content;
  margin-bottom: 8px;

  &[data-expanded='false'] {
    cursor: pointer;
  }
`

export const StyledStickySponsoredByIcon = styled.img`
  width: 18px;
  height: 18px;
  margin-right: 8px;

  &[data-expanded='true'] {
    cursor: pointer;
  }
`

export const StyledStickySponsoredByContent = styled.div`
  .sponsor-explanation {
    cursor: pointer;
  }

  &[data-expanded='true'] {
    .sponsor-text {
      font-weight: ${(props: ThemeProps) => props.theme.sizes.fwBold};
    }
  }
`
